(function () {
  'use strict';

  var SCRIPT_ID = 'upcart-custom-gifts-script';

  if (document.getElementById(SCRIPT_ID)) return;
  if (window.DISABLE_UPCART_GIFTS === true) return;

  var scriptIdentifier = document.createElement('div');
  scriptIdentifier.id = SCRIPT_ID;
  scriptIdentifier.setAttribute('data-upcart-gifts-enabled', 'true');
  scriptIdentifier.style.display = 'none';
  document.head.appendChild(scriptIdentifier);


  /* Hidden by default.
     Intelligems (enable) — prefer the window flag (avoids class MutationObserver fights):
       window.UPCART_GIFTS_NEW = true;
     Also accepted:
       document.documentElement.classList.add('ig-upcart-gifts-new');
  */

  var NEW_STYLE_ID = 'ig-upcart-gifts-new-css';
  var newStylesApplied = false;
  var giftsFeatureStarted = false;
  var syncingVariant = false;
  var lastEnabledState = null;
  var classWatchMo = null;

  function isGiftsEnabled() {
    if (window.DISABLE_UPCART_GIFTS === true) return false;

    var giftsVariantActive =
      window.UPCART_GIFTS_NEW === true ||
      document.documentElement.classList.contains('ig-upcart-gifts-new') ||
      (document.body && document.body.classList.contains('ig-upcart-gifts-new'));

    /* Bundle clarity (released winner) uses the animal picker on PDPs.
       Suppress the cart gifts accordion there unless the gifts summary
       experiment is explicitly active. */
    if (
      !giftsVariantActive &&
      document.querySelector('quantity-breaks[data-animal-picker="true"]')
    ) {
      return false;
    }

    return giftsVariantActive;
  }

  function isCartTrustEnabled() {
    var html = document.documentElement;
    return (
      html.classList.contains('ab-cart-trust') ||
      html.classList.contains('ab-cart-trust-restart') ||
      html.classList.contains('ab-cart-trust-restart-v2')
    );
  }

  function shouldAutoOpenGiftsSummary() {
    return !isCartTrustEnabled();
  }

  function tearDownGiftsUI() {
    var summary = document.getElementById('upcart-gifts-summary');
    if (summary) summary.remove();

    var styleEl = document.getElementById(NEW_STYLE_ID);
    if (styleEl) styleEl.remove();
    newStylesApplied = false;

    var root = getCartRoot();
    if (!root) return;
    var hiddenGifts = root.querySelectorAll('.upcart-product-item[style*="display: none"], [class*="product-item"][style*="display: none"]');
    hiddenGifts.forEach(function (item) {
      if (isFreeProductItem(item)) {
        item.style.removeProperty('display');
      }
    });
  }

  function syncNewGiftsVariant() {
    if (syncingVariant) return;
    var enabled = isGiftsEnabled();

    /* Skip no-op re-entry — Intelligems preview re-applies classes often */
    if (enabled === lastEnabledState && (!enabled || giftsFeatureStarted)) {
      return;
    }

    syncingVariant = true;
    try {
      if (!enabled) {
        lastEnabledState = false;
        giftsFeatureStarted = false;
        tearDownGiftsUI();
        pauseObserver();
        return;
      }

      lastEnabledState = true;

      if (!document.documentElement.classList.contains('ig-upcart-gifts-new')) {
        document.documentElement.classList.add('ig-upcart-gifts-new');
      }
      if (document.body && !document.body.classList.contains('ig-upcart-gifts-new')) {
        document.body.classList.add('ig-upcart-gifts-new');
      }
      var summary = document.getElementById('upcart-gifts-summary');
      if (summary && !summary.classList.contains('ig-upcart-gifts-new')) {
        summary.classList.add('ig-upcart-gifts-new');
      }
      injectNewGiftsStyles();

      if (!giftsFeatureStarted) {
        giftsFeatureStarted = true;
        bindObserver();
        scheduleInit();
      }
    } finally {
      syncingVariant = false;
    }
  }

  function injectNewGiftsStyles() {
    if (newStylesApplied || document.getElementById(NEW_STYLE_ID)) {
      newStylesApplied = true;
      return;
    }
    var s = document.createElement('style');
    s.id = NEW_STYLE_ID;
    s.textContent =
      '#upcart-gifts-summary.ig-upcart-gifts-new,' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary{' +
        'border:1px solid rgba(52,168,83,0.25)!important;' +
        'border-radius:5px!important;' +
        'margin:12px!important;' +
        'min-height:48px!important;' +
        'background:#fff!important;' +
        'padding:0!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-toggle,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-toggle,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-toggle{' +
        'background:#d8e2dc!important;' +
        'color:#32444e!important;' +
        'padding:12px 16px!important;' +
        'min-height:48px!important;' +
        'gap:5px!important;' +
        'font-size:15px!important;' +
        'font-weight:700!important;' +
        'border-radius:5px!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary.upcart-gifts-open .upcart-gifts-summary-toggle,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary.upcart-gifts-open .upcart-gifts-summary-toggle,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new.upcart-gifts-open .upcart-gifts-summary-toggle{' +
        'border-radius:5px 5px 0 0!important;' +
        'border-bottom:none!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-label{gap:5px!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label>span:first-child,' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label>span:first-child svg,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label>span:first-child,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-label>span:first-child svg,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-label>span:first-child,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-label>span:first-child svg{' +
        'width:24px!important;height:24px!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-text,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-text,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-text{' +
        'color:#32444e!important;font-size:15px!important;font-weight:700!important;line-height:20px!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-meta,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-summary-meta,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-summary-meta{gap:5px!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-total-compare,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-total-compare,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-total-compare{' +
        'color:#32444e!important;font-weight:400!important;font-size:15px!important;opacity:1!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-total-free,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-total-free,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-total-free{' +
        'color:#32444e!important;font-weight:700!important;font-size:15px!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-collapsible-wrapper,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-collapsible-wrapper,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-collapsible-wrapper{padding:0 17px!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary.upcart-gifts-open .upcart-gifts-collapsible-wrapper,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary.upcart-gifts-open .upcart-gifts-collapsible-wrapper,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new.upcart-gifts-open .upcart-gifts-collapsible-wrapper{' +
        'padding:16px 17px 12px!important;max-height:1000px;opacity:1;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-list,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-list,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-list{gap:10px!important;padding:0!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-item-cloned,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-item-cloned,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-item-cloned{' +
        'padding:0 0 10px!important;border-bottom:0.5px solid rgba(0,0,0,0.1)!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-item-cloned:last-child,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-item-cloned:last-child,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-item-cloned:last-child{' +
        'border-bottom:none!important;padding-bottom:0!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-left-group,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-left-group,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-left-group{gap:5px!important;margin-right:8px!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-clean-title,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-clean-title,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-clean-title{' +
        'color:#000!important;' +
        'font-family:Inter,sans-serif!important;' +
        'font-size:15px!important;' +
        'font-style:normal!important;' +
        'font-weight:700!important;' +
        'line-height:20px!important;' +
        'white-space:nowrap!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-wrap,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-wrap,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-price-wrap{gap:5px!important;display:flex!important;}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-compare,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-compare,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-price-compare{' +
        'color:#000!important;' +
        'font-family:Inter,sans-serif!important;' +
        'font-size:15px!important;' +
        'font-style:normal!important;' +
        'font-weight:400!important;' +
        'line-height:20px!important;' +
        'text-decoration-line:line-through!important;' +
        'opacity:1!important;margin:0!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-free,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gift-price-free,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gift-price-free{' +
        'color:#000!important;' +
        'font-family:Inter,sans-serif!important;' +
        'font-size:15px!important;' +
        'font-style:normal!important;' +
        'font-weight:700!important;' +
        'line-height:20px!important;' +
      '}' +
      'html.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-footer-note,' +
      'body.ig-upcart-gifts-new #upcart-gifts-summary .upcart-gifts-footer-note,' +
      '#upcart-gifts-summary.ig-upcart-gifts-new .upcart-gifts-footer-note{' +
        'margin:10px 0 0!important;padding:14px 0 0!important;' +
        'border-top:0.5px solid rgba(0,0,0,0.1)!important;' +
        'font-size:12px!important;color:#000!important;opacity:1!important;' +
      '}';
    document.head.appendChild(s);
    try {
      var udoc = getUpcartDoc();
      if (udoc && udoc !== document && udoc.nodeType === 11 && !udoc.getElementById(NEW_STYLE_ID)) {
        udoc.appendChild(s.cloneNode(true));
      }
    } catch (e) {}
    newStylesApplied = true;
  }

  function watchNewGiftsVariant() {
    syncNewGiftsVariant();
    var checks = 0;
    var timer = setInterval(function () {
      syncNewGiftsVariant();
      checks += 1;
      if (checks >= 60) clearInterval(timer); /* 30s for late Intelligems */
    }, 500);

    /* Poll window flag (Intelligems Custom JS often sets this after load) */
    try {
      var flagPoll = 0;
      var flagTimer = setInterval(function () {
        if (window.UPCART_GIFTS_NEW === true) syncNewGiftsVariant();
        flagPoll += 1;
        if (flagPoll >= 60 || giftsFeatureStarted) clearInterval(flagTimer);
      }, 500);
    } catch (e) {}

    try {
      if (classWatchMo) return;
      var classDebounce = null;
      classWatchMo = new MutationObserver(function () {
        if (syncingVariant) return;
        clearTimeout(classDebounce);
        classDebounce = setTimeout(function () {
          syncNewGiftsVariant();
          if (isCartTrustEnabled() && !userControllingGiftsSummary) {
            closeGiftsSummary(true);
          }
        }, 100);
      });
      classWatchMo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: false });
      if (document.body) {
        classWatchMo.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: false });
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          if (document.body) {
            classWatchMo.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: false });
          }
          syncNewGiftsVariant();
        });
      }
    } catch (e) {}
  }

  var debounceTimer = null;
  var observer = null;
  var isUpdatingGifts = false;
  var productPriceCache = {};
  var drawerFinder = null;
  var cartDrawerWasOpen = false;
  var userControllingGiftsSummary = false;
  var cartOpenWatchMo = null;
  var upcartOpenHooked = false;

  function getUpcartDoc() {
    return window.upcartDocumentOrShadowRoot || document;
  }

  function getCartRoot() {
    var doc = getUpcartDoc();
    var root =
      doc.querySelector(
        'upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, .upcart-cart, .upcart-cart-body, [class*="upcart-cart"]'
      ) || null;

    /* Shadow root itself can be the searchable root */
    if (!root && doc && doc.nodeType === 11) root = doc;
    return root;
  }

  function pauseObserver() {
    if (observer) observer.disconnect();
  }

  function resumeObserver() {
    if (!observer || !isGiftsEnabled()) return;
    var root = getCartRoot();
    if (!root) {
      waitForCartRoot();
      return;
    }
    /* Never observe document.body — Intelligems preview mutates the page constantly
       and that created an infinite render loop ("Page Unresponsive"). */
    try {
      observer.observe(root, { childList: true, subtree: true });
    } catch (e) {}
  }

  function waitForCartRoot() {
    if (getCartRoot()) {
      hookUpCartOpen();
      bindCartOpenWatcher();
      resumeObserver();
      scheduleInit();
      return;
    }
    if (drawerFinder) return;
    drawerFinder = setInterval(function () {
      if (!isGiftsEnabled()) return;
      if (getCartRoot()) {
        clearInterval(drawerFinder);
        drawerFinder = null;
        hookUpCartOpen();
        bindCartOpenWatcher();
        resumeObserver();
        scheduleInit();
      }
    }, 500);
  }

  function getGiftsSummaryEl() {
    var doc = getUpcartDoc();
    return (
      (doc.getElementById && doc.getElementById('upcart-gifts-summary')) ||
      document.getElementById('upcart-gifts-summary')
    );
  }

  function openGiftsSummary() {
    if (!shouldAutoOpenGiftsSummary()) return;
    var summary = getGiftsSummaryEl();
    if (!summary) return;
    summary.classList.add('upcart-gifts-open');
    var toggle = summary.querySelector('.upcart-gifts-summary-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeGiftsSummary(force) {
    if (!force && userControllingGiftsSummary) return;
    var summary = getGiftsSummaryEl();
    if (!summary) return;
    summary.classList.remove('upcart-gifts-open');
    var toggle = summary.querySelector('.upcart-gifts-summary-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function bindGiftsSummaryToggle(summary) {
    if (!summary || summary.dataset.giftsToggleBound === 'true') return;
    summary.dataset.giftsToggleBound = 'true';
    summary.addEventListener(
      'click',
      function (e) {
        var toggle = e.target.closest('.upcart-gifts-summary-toggle');
        if (!toggle || !summary.contains(toggle)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        userControllingGiftsSummary = true;
        var isOpen = summary.classList.toggle('upcart-gifts-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      },
      true
    );
  }

  function findCartDrawerEl() {
    var doc = getUpcartDoc();
    var drawer = doc.querySelector(
      '#UpcartPopup, upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, [class*="UpcartPopup"], [class*="upcart-drawer"]'
    );
    if (!drawer && doc !== document) {
      drawer = document.querySelector(
        '#UpcartPopup, upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, [class*="UpcartPopup"], [class*="upcart-drawer"]'
      );
    }
    return drawer;
  }

  function scheduleOpenGiftsSummary() {
    if (!shouldAutoOpenGiftsSummary()) return;
    openGiftsSummary();
    setTimeout(openGiftsSummary, 300);
    setTimeout(openGiftsSummary, 700);
  }

  function resetGiftsSummaryForNextCartOpen() {
    userControllingGiftsSummary = false;
    if (shouldAutoOpenGiftsSummary()) {
      scheduleOpenGiftsSummary();
      return;
    }
    closeGiftsSummary(true);
  }

  function resetGiftsSummaryOnCartOpen() {
    cartDrawerWasOpen = false;
    userControllingGiftsSummary = false;
    if (shouldAutoOpenGiftsSummary()) {
      scheduleOpenGiftsSummary();
      return;
    }
    closeGiftsSummary(true);
  }

  function isCartDrawerOpen() {
    var drawer = findCartDrawerEl();
    if (!drawer) return false;

    if (drawer.getAttribute('aria-hidden') === 'true') return false;
    if (drawer.getAttribute('aria-hidden') === 'false') return true;

    var className = drawer.className || '';
    if (/\b(closed|is-closed|hidden)\b/i.test(className)) return false;
    if (/\b(open|is-open|active|visible|shown)\b/i.test(className)) return true;

    try {
      var style = window.getComputedStyle(drawer);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (parseFloat(style.opacity) === 0) return false;
      var rect = drawer.getBoundingClientRect();
      if (rect.width <= 20 || rect.height <= 20) return false;
      if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
      return true;
    } catch (e) {}

    return false;
  }

  function onCartOpenStateChange() {
    if (!isGiftsEnabled()) return;
    var isOpen = isCartDrawerOpen();
    if (cartDrawerWasOpen && !isOpen) {
      resetGiftsSummaryForNextCartOpen();
    } else if (isOpen && !cartDrawerWasOpen) {
      userControllingGiftsSummary = false;
      if (shouldAutoOpenGiftsSummary()) {
        scheduleOpenGiftsSummary();
      } else {
        closeGiftsSummary(true);
      }
    }
    cartDrawerWasOpen = isOpen;
  }

  function bindCartOpenWatcher() {
    var drawer = findCartDrawerEl();
    if (!drawer || drawer.dataset.giftsOpenWatch === 'true') return;
    drawer.dataset.giftsOpenWatch = 'true';

    if (cartOpenWatchMo) cartOpenWatchMo.disconnect();
    cartOpenWatchMo = new MutationObserver(function () {
      onCartOpenStateChange();
    });
    cartOpenWatchMo.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'open', 'data-open']
    });
  }

  function hookUpCartOpen() {
    if (upcartOpenHooked || !window.UpCart) return;
    upcartOpenHooked = true;
    ['open', 'openCart'].forEach(function (method) {
      if (typeof window.UpCart[method] !== 'function') return;
      var original = window.UpCart[method];
      window.UpCart[method] = function () {
        var result = original.apply(this, arguments);
        setTimeout(resetGiftsSummaryOnCartOpen, 100);
        return result;
      };
    });
    ['close', 'closeCart'].forEach(function (method) {
      if (typeof window.UpCart[method] !== 'function') return;
      var original = window.UpCart[method];
      window.UpCart[method] = function () {
        var result = original.apply(this, arguments);
        cartDrawerWasOpen = false;
        setTimeout(resetGiftsSummaryForNextCartOpen, 100);
        return result;
      };
    });
  }

  function openUpCartDrawer() {
    if (window.UpCart) {
      if (typeof window.UpCart.open === 'function') {
        window.UpCart.open();
      } else if (typeof window.UpCart.openCart === 'function') {
        window.UpCart.openCart();
      }
    }
  }

  function isFreeProductItem(item) {
    if (item.classList.contains('upcart-gift-item')) return true;

    var strongs = item.querySelectorAll('.upcart-item-property strong');
    for (var i = 0; i < strongs.length; i++) {
      if (strongs[i].textContent.trim().indexOf('_free_product') !== -1) {
        var span = strongs[i].nextElementSibling;
        if (span && span.textContent.trim() === 'true') return true;
      }
    }

    var text = item.innerText || '';
    if (text.indexOf('_free_product') !== -1 || text.toLowerCase().indexOf('free gift') !== -1) {
      return true;
    }

    var giftProp = item.querySelector('.upcart-gift-prop-hidden, [class*="upcart-gift"]');
    return !!giftProp;
  }

  function findGiftItems(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.upcart-product-item, [class*="product-item"]'));
    return items.filter(function (item) {
      if (item.closest('#upcart-gifts-summary')) return false;
      return isFreeProductItem(item);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantId(item) {
    var raw = item.id || item.getAttribute('data-variant-id') || '';
    return raw.split(':')[0];
  }

  function getProductHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  }

  function fetchProductPrice(handle, variantId, callback) {
    if (productPriceCache[handle]) {
      callback(productPriceCache[handle][variantId]);
      return;
    }
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var map = {};
        (product.variants || []).forEach(function (v) {
          map[String(v.id)] = {
            title: product.title,
            price: v.price,
            compareAtPrice: v.compare_at_price
          };
        });
        productPriceCache[handle] = map;
        callback(map[variantId]);
      })
      .catch(function () { callback(null); });
  }

  function disableGiftLinks() {
    var giftContainer = document.getElementById('upcart-gifts-summary') || document;
    var giftLinks = giftContainer.querySelectorAll('a, .upcart-product-title a, .upcart-item-title a');
    giftLinks.forEach(function (link) {
      if (link.dataset.giftDisabled === 'true') return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
      link.style.textDecoration = 'none';
      link.style.color = 'inherit';
      link.dataset.giftDisabled = 'true';
    });
  }

  function checkAndToggleVisibility() {
    var root = getCartRoot();
    if (!root) return;
    var allItems = Array.prototype.slice.call(root.querySelectorAll('.upcart-product-item, [data-upcart-item], .upcart-item'));

    var paidProducts = allItems.filter(function(item) {
      if (item.closest('#upcart-gifts-summary')) return false;
      return !isFreeProductItem(item);
    });

    var summary = document.getElementById('upcart-gifts-summary');
    if (summary) {
      if (paidProducts.length === 0) {
        summary.style.setProperty('display', 'none', 'important');
      } else {
        summary.style.setProperty('display', 'block', 'important');
      }
    }
  }

  function buildCleanGiftRow(rawItem, done) {
    var img = rawItem.querySelector('img');
    var titleEl = rawItem.querySelector('.upcart-product-title, .upcart-item-title, a[href*="/products/"]');

    var imgSrc = img ? img.src : '';
    var imgAlt = img ? img.alt : '';

    var rawTitleText = titleEl ? titleEl.textContent.trim() : (imgAlt || 'Free Gift');
    var cleanTitleText = rawTitleText.replace(/^Free Gift[:\s-]*/i, '').trim() || 'Free Gift';

    var row = document.createElement('div');
    row.className = 'upcart-gift-item-cloned';

    var leftGroup = document.createElement('div');
    leftGroup.className = 'upcart-gift-left-group';

    if (imgSrc) {
      var thumb = document.createElement('img');
      thumb.src = imgSrc;
      thumb.alt = imgAlt;
      thumb.className = 'upcart-gift-thumb';
      leftGroup.appendChild(thumb);
    }

    var titleSpan = document.createElement('span');
    titleSpan.className = 'upcart-gift-clean-title';
    titleSpan.textContent = cleanTitleText;
    leftGroup.appendChild(titleSpan);

    var priceWrap = document.createElement('div');
    priceWrap.className = 'upcart-gift-price-wrap';

    row.appendChild(leftGroup);
    row.appendChild(priceWrap);

    var variantId = getVariantId(rawItem);
    var handle = getProductHandle(rawItem);

    if (!handle) {
      priceWrap.innerHTML = '<span class="upcart-gift-price-free">FREE</span>';
      done(row, 0);
      return;
    }

    fetchProductPrice(handle, variantId, function (data) {
      if (data && data.title) {
        titleSpan.textContent = data.title;
      }
      var compareAtCents = 0;
      if (data && data.compareAtPrice) {
        compareAtCents = parseInt(data.compareAtPrice, 10) || 0;
      } else if (data && data.price) {
        compareAtCents = parseInt(data.price, 10) || 0;
      }

      var compareHTML = compareAtCents > 0
        ? '<s class="upcart-gift-price-compare">' + formatMoney(compareAtCents) + '</s>'
        : '';

      priceWrap.innerHTML = compareHTML + '<span class="upcart-gift-price-free">FREE</span>';
      done(row, compareAtCents);
    });
  }

  function findPaidProductItems(root) {
    var allItems = Array.prototype.slice.call(
      root.querySelectorAll('.upcart-product-item, [data-upcart-item], .upcart-item, [class*="product-item"]')
    );
    return allItems.filter(function (item) {
      if (item.closest('#upcart-gifts-summary')) return false;
      return !isFreeProductItem(item);
    });
  }

  function findProductsList(root) {
    return (
      root.querySelector('.upcart-products-section, .upcart-items, [class*="items-list"], [class*="ProductsList"], [class*="product-list"]') ||
      getUpcartDoc().querySelector('.upcart-products-section, .upcart-items, [class*="items-list"]')
    );
  }

  /* Keep accordion directly under paid products — not after cart-body / footer */
  function placeSummary(summary, root) {
    if (!summary || !root) return;

    var paid = findPaidProductItems(root);
    var lastPaid = paid.length ? paid[paid.length - 1] : null;

    if (lastPaid && lastPaid.parentNode) {
      if (summary.previousElementSibling !== lastPaid) {
        lastPaid.parentNode.insertBefore(summary, lastPaid.nextSibling);
      }
      return;
    }

    var list = findProductsList(root);
    if (list) {
      if (summary.parentNode !== list) {
        list.appendChild(summary);
      }
      return;
    }
  }

  function ensureSummary(root) {
    var doc = getUpcartDoc();
    var summary =
      (doc.getElementById && doc.getElementById('upcart-gifts-summary')) ||
      document.getElementById('upcart-gifts-summary');

    if (!summary) {
      summary = document.createElement('div');
      summary.id = 'upcart-gifts-summary';
      summary.className = shouldAutoOpenGiftsSummary()
        ? 'upcart-gifts-summary upcart-gifts-open'
        : 'upcart-gifts-summary';

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'upcart-gifts-summary-toggle';
      toggle.setAttribute('aria-expanded', shouldAutoOpenGiftsSummary() ? 'true' : 'false');

      var label = document.createElement('span');
      label.className = 'upcart-gifts-summary-label';

      var iconWrap = document.createElement('span');
      iconWrap.setAttribute('aria-hidden', 'true');
      iconWrap.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
        '<path d="M20.25 6.75131H16.9613C16.9978 6.72037 17.0353 6.69037 17.0709 6.65756C17.3557 6.4046 17.5851 6.09561 17.745 5.74992C17.9049 5.40423 17.9917 5.02927 18 4.6485C18.0123 4.23194 17.9394 3.81726 17.7856 3.42992C17.6319 3.04258 17.4006 2.69075 17.106 2.39603C16.8113 2.1013 16.4596 1.86991 16.0723 1.71605C15.685 1.56219 15.2703 1.48912 14.8538 1.50131C14.4728 1.50951 14.0977 1.59626 13.7518 1.75613C13.406 1.91599 13.0968 2.14553 12.8438 2.43037C12.4936 2.83621 12.2089 3.29422 12 3.78787C11.7911 3.29422 11.5064 2.83621 11.1562 2.43037C10.9032 2.14553 10.594 1.91599 10.2482 1.75613C9.90232 1.59626 9.52718 1.50951 9.14625 1.50131C8.72969 1.48912 8.31503 1.56219 7.92774 1.71605C7.54044 1.86991 7.18868 2.1013 6.89405 2.39603C6.59941 2.69075 6.36812 3.04258 6.21438 3.42992C6.06064 3.81726 5.98768 4.23194 6 4.6485C6.00833 5.02927 6.09514 5.40423 6.255 5.74992C6.41486 6.09561 6.64434 6.4046 6.92906 6.65756C6.96469 6.6885 7.00219 6.7185 7.03875 6.75131H3.75C3.35218 6.75131 2.97064 6.90934 2.68934 7.19065C2.40804 7.47195 2.25 7.85348 2.25 8.25131V11.2513C2.25 11.6491 2.40804 12.0307 2.68934 12.312C2.97064 12.5933 3.35218 12.7513 3.75 12.7513V18.7513C3.75 19.1491 3.90804 19.5307 4.18934 19.812C4.47064 20.0933 4.85218 20.2513 5.25 20.2513H18.75C19.1478 20.2513 19.5294 20.0933 19.8107 19.812C20.092 19.5307 20.25 19.1491 20.25 18.7513V12.7513C20.6478 12.7513 21.0294 12.5933 21.3107 12.312C21.592 12.0307 21.75 11.6491 21.75 11.2513V8.25131C21.75 7.85348 21.592 7.47195 21.3107 7.19065C21.0294 6.90934 20.6478 6.75131 20.25 6.75131ZM13.9688 3.42412C14.0875 3.29298 14.2321 3.18781 14.3934 3.11522C14.5547 3.04262 14.7293 3.00415 14.9062 3.00225H14.9522C15.1595 3.00354 15.3645 3.04621 15.5552 3.12775C15.7458 3.20929 15.9183 3.32806 16.0624 3.4771C16.2066 3.62615 16.3195 3.80246 16.3947 3.99572C16.4698 4.18898 16.5056 4.39529 16.5 4.60256C16.4981 4.77946 16.4596 4.95406 16.387 5.1154C16.3144 5.27673 16.2093 5.42131 16.0781 5.54006C15.1884 6.32756 13.7119 6.60506 12.7969 6.70256C12.9094 5.70975 13.2188 4.26693 13.9688 3.42412ZM7.96031 3.45787C8.25088 3.16733 8.64441 3.00325 9.05531 3.00131H9.10125C9.27815 3.00322 9.45275 3.04168 9.61409 3.11428C9.77542 3.18688 9.92 3.29205 10.0388 3.42318C10.8253 4.31193 11.1028 5.78568 11.2003 6.69693C10.2891 6.60318 8.81531 6.32193 7.92656 5.53537C7.79543 5.41662 7.69026 5.27204 7.61766 5.11071C7.54506 4.94938 7.5066 4.77478 7.50469 4.59787C7.49887 4.38715 7.53593 4.17745 7.61361 3.98149C7.69128 3.78552 7.80796 3.60738 7.95656 3.45787H7.96031ZM3.75 8.25131H11.25V11.2513H3.75V8.25131ZM5.25 12.7513H11.25V18.7513H5.25V12.7513ZM18.75 18.7513H12.75V12.7513H18.75V18.7513ZM20.25 11.2513H12.75V8.25131H20.25V11.2513Z" fill="#32444E"/>' +
        '</svg>';
      label.appendChild(iconWrap);

      var text = document.createElement('span');
      text.className = 'upcart-gifts-summary-text';
      label.appendChild(text);

      var chevronWrap = document.createElement('span');
      chevronWrap.setAttribute('aria-hidden', 'true');
      chevronWrap.innerHTML =
        '<svg class="upcart-gifts-chevron" width="10" height="10" viewBox="0 0 20 20" fill="none">' +
        '<path d="M5 7l5 5 5-5" stroke="#32444E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      label.appendChild(chevronWrap);

      var meta = document.createElement('span');
      meta.className = 'upcart-gifts-summary-meta';

      var compare = document.createElement('s');
      compare.className = 'upcart-gifts-total-compare';

      var free = document.createElement('span');
      free.className = 'upcart-gifts-total-free';
      free.textContent = 'FREE';

      meta.appendChild(compare);
      meta.appendChild(free);

      toggle.appendChild(label);
      toggle.appendChild(meta);

      var collapsibleWrapper = document.createElement('div');
      collapsibleWrapper.className = 'upcart-gifts-collapsible-wrapper';

      var list = document.createElement('div');
      list.className = 'upcart-gifts-list';

      var footer = document.createElement('div');
      footer.className = 'upcart-gifts-footer-note';
      footer.textContent = 'Gifts are added automatically with your order';

      collapsibleWrapper.appendChild(list);
      collapsibleWrapper.appendChild(footer);

      summary.appendChild(toggle);
      summary.appendChild(collapsibleWrapper);
    }

    bindGiftsSummaryToggle(summary);
    placeSummary(summary, root);
    return summary;
  }

  function renderGifts() {
    if (!isGiftsEnabled()) {
      tearDownGiftsUI();
      return;
    }
    if (isUpdatingGifts) return;
    isUpdatingGifts = true;
    pauseObserver();
    syncNewGiftsVariant();

    var root = getCartRoot();
    if (!root) {
      isUpdatingGifts = false;
      waitForCartRoot();
      return;
    }

    var giftItems = findGiftItems(root);

    checkAndToggleVisibility();

    if (giftItems.length === 0) {
      var summaryEl =
        (getUpcartDoc().getElementById && getUpcartDoc().getElementById('upcart-gifts-summary')) ||
        document.getElementById('upcart-gifts-summary');
      if (summaryEl) summaryEl.style.setProperty('display', 'none', 'important');
      isUpdatingGifts = false;
      resumeObserver();
      return;
    }

    var summary = ensureSummary(root);
    syncNewGiftsVariant();
    checkAndToggleVisibility();

    var list = summary.querySelector('.upcart-gifts-list');
    list.innerHTML = '';

    var totalCents = 0;
    var remaining = giftItems.length;

    giftItems.forEach(function (rawItem) {
      rawItem.style.setProperty('display', 'none', 'important');

      buildCleanGiftRow(rawItem, function (rowElement, cents) {
        list.appendChild(rowElement);
        totalCents += cents;
        remaining -= 1;

        if (remaining === 0) {
          var compareEl = summary.querySelector('.upcart-gifts-total-compare');
          var freeEl = summary.querySelector('.upcart-gifts-total-free');
          if (compareEl && freeEl) {
            if (totalCents > 0) {
              compareEl.textContent = formatMoney(totalCents);
              compareEl.style.display = 'inline';
            } else {
              compareEl.textContent = '';
              compareEl.style.display = 'none';
            }
            freeEl.textContent = 'FREE';
          }
          disableGiftLinks();
          placeSummary(summary, root);
          checkAndToggleVisibility();
          isUpdatingGifts = false;
          resumeObserver();
        }
      });
    });

    var summaryTextEl = summary.querySelector('.upcart-gifts-summary-text');
    if (summaryTextEl) {
      summaryTextEl.textContent =
        giftItems.length + (giftItems.length === 1 ? ' Free Gift Included' : ' Free Gifts Included');
    }
  }

  function scheduleInit() {
    if (!isGiftsEnabled()) return;
    if (isUpdatingGifts) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      renderGifts();
    }, 150);
  }

  function isIgnoredGiftMutationElement(element) {
    if (!element || element.nodeType !== 1) return false;
    if (
      element.id === 'upcart-gifts-summary' ||
      element.id === 'upcart-cart-recommendation' ||
      element.id === 'upcart-cart-recommendation-skeleton' ||
      element.id === 'upcart-cart-recommendation-mount' ||
      element.id === 'upcart-cart-savings' ||
      element.id === 'upcart-cart-trust-badge'
    ) {
      return true;
    }
    if (element.hasAttribute && element.hasAttribute('data-upcart-trust-upsell-hidden')) {
      return true;
    }
    if (element.closest) {
      if (element.closest('#upcart-gifts-summary')) return true;
      if (
        element.closest(
          '#upcart-cart-recommendation, #upcart-cart-recommendation-skeleton, #upcart-cart-recommendation-mount, #upcart-cart-savings, #upcart-cart-trust-badge'
        )
      ) {
        return true;
      }
    }
    return false;
  }

  function isIgnoredGiftMutation(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && isIgnoredGiftMutationElement(target)) return true;

    var changedNodes = Array.prototype.slice.call(mutation.addedNodes)
      .concat(Array.prototype.slice.call(mutation.removedNodes));
    if (!changedNodes.length) return false;

    return changedNodes.every(isIgnoredGiftMutationElement);
  }

  function bindObserver() {
    if (observer) {
      resumeObserver();
      return;
    }
    observer = new MutationObserver(function (mutations) {
      if (isUpdatingGifts || syncingVariant || !isGiftsEnabled()) return;
      if (mutations.every(isIgnoredGiftMutation)) return;
      scheduleInit();
    });
    resumeObserver();
  }

  function interceptFetchCartChanges() {
    var originalFetch = window.fetch;
    if (window._originalFetch) return;
    window._originalFetch = originalFetch;

    window.fetch = function () {
      var firstArg = arguments[0];
      var url = typeof firstArg === 'string' ? firstArg : (firstArg && firstArg.url ? firstArg.url : '');

      return originalFetch.apply(this, arguments).then(function (response) {
        if (typeof url === 'string' && (url.indexOf('/cart/') !== -1)) {
          var mayOpenCart = url.indexOf('/cart/add') !== -1;
          setTimeout(function () {
            if (mayOpenCart) resetGiftsSummaryOnCartOpen();
            bindCartOpenWatcher();
            checkAndToggleVisibility();
            scheduleInit();
          }, mayOpenCart ? 300 : 50);
        }
        return response;
      });
    };
  }


  document.addEventListener('click', function(e) {
    if (!isGiftsEnabled()) return;
    var target = e.target;
    if (!target || !target.closest) return;

    var cartTrigger = target.closest(
      '#cart-icon-bubble, [data-nuora-upcart-trigger], .header__icon--cart'
    );
    if (cartTrigger) {
      setTimeout(resetGiftsSummaryOnCartOpen, 300);
    }

    var cartRoot = target.closest(
      '#UpcartPopup, upcart-drawer, .upcart-drawer, #upcart-drawer, #upCart, .upcart-cart, [class*="UpcartPopup"]'
    );
    if (
      cartRoot &&
      !target.closest('.upcart-gifts-summary-toggle, #upcart-gifts-summary') &&
      target.closest(
        '[class*="close"], [class*="Close"], [class*="backdrop"], [class*="Backdrop"], [class*="overlay"], [class*="Overlay"], [aria-label*="close"], [aria-label*="Close"]'
      )
    ) {
      cartDrawerWasOpen = false;
      setTimeout(resetGiftsSummaryForNextCartOpen, 50);
    }

    /* Re-try render when cart is opened or changed */
    setTimeout(function () {
      if (!observer) bindObserver();
      else resumeObserver();
      bindCartOpenWatcher();
      onCartOpenStateChange();
      scheduleInit();
    }, 400);

    if (
      target.closest('upcart-drawer, .upcart-drawer, #upcart-drawer, #upCart, .upcart-cart') &&
      (target.matches('[class*="remove"], [class*="delete"], [class*="trash"], svg, path, button') || target.closest('button, a'))
    ) {
      setTimeout(function() {
        checkAndToggleVisibility();
        scheduleInit();
      }, 150);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!isGiftsEnabled() || e.key !== 'Escape') return;
    setTimeout(function () {
      if (!isCartDrawerOpen()) {
        cartDrawerWasOpen = false;
        resetGiftsSummaryForNextCartOpen();
      }
    }, 150);
  });

  interceptFetchCartChanges();
  /* Do NOT bindObserver() until the variant is enabled — observing body/page
     while Intelligems preview mutates the DOM freezes the tab. */
  watchNewGiftsVariant();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncNewGiftsVariant();
    });
  }

  document.addEventListener('upcart_updated', function () {
    if (!isGiftsEnabled()) return;
    bindCartOpenWatcher();
    onCartOpenStateChange();
    checkAndToggleVisibility();
    scheduleInit();
  });

  hookUpCartOpen();
})();